export interface AssistDecisionOption {
  id: string;
  label: string;
  nextNodeId?: string;
  resultId?: string;
}

export interface AssistDecisionNode {
  id: string;
  prompt: string;
  options: AssistDecisionOption[];
}

export interface AssistDecisionResult {
  id: string;
  title: string;
  summary: string;
  suggestions: string[];
}

export interface AssistDecisionTree {
  id: string;
  title: string;
  description: string;
  rootNodeId: string;
  nodes: AssistDecisionNode[];
  results: AssistDecisionResult[];
}

export const demoDecisionTree: AssistDecisionTree = {
  id: "biais-confirmation-decision-tree",
  title: "Suspectes-tu un biais de confirmation ?",
  description: "Arbre rapide pour analyser si tu filtres trop les informations dans une situation donnée.",
  rootNodeId: "node-1",
  nodes: [
    {
      id: "node-1",
      prompt: "As-tu recherché des informations opposées à ton idée initiale ?",
      options: [
        { id: "opt-1-yes", label: "Oui", nextNodeId: "node-2" },
        { id: "opt-1-no", label: "Non", nextNodeId: "node-3" },
      ],
    },
    {
      id: "node-2",
      prompt: "As-tu lu/écouté ces informations opposées jusqu'au bout ?",
      options: [
        { id: "opt-2-yes", label: "Oui, entièrement", resultId: "res-2" },
        { id: "opt-2-no", label: "Non, j'ai stoppé dès que j'étais en désaccord", resultId: "res-1" },
      ],
    },
    {
      id: "node-3",
      prompt: "Souhaites-tu chercher au moins une source contradictoire ?",
      options: [
        { id: "opt-3-yes", label: "Oui", resultId: "res-2" },
        { id: "opt-3-no", label: "Non", resultId: "res-1" },
      ],
    },
  ],
  results: [
    {
      id: "res-1",
      title: "Biais probable",
      summary: "Tu risques d'être sous biais de confirmation : tu filtres ou ignores les sources opposées.",
      suggestions: [
        "Lire au moins une source crédible qui contredit ton idée.",
        "Noter ce qui te dérange dans ces sources et pourquoi.",
        "Comparer les arguments et chercher des faits vérifiables.",
      ],
    },
    {
      id: "res-2",
      title: "Tu as déjà pris du recul",
      summary: "Tu as exploré des sources opposées : c'est un bon réflexe pour limiter le biais.",
      suggestions: [
        "Vérifie si tu as accordé le même temps aux sources opposées.",
        "Liste les points que tu changes dans ton avis grâce à ces sources.",
        "Partage ton analyse avec quelqu'un pour confronter ton raisonnement.",
      ],
    },
  ],
};
